import { FrequenciesFilterField, FrequenciesFilterState, FrequencyHealthStatus, FrequencyRow, SignalLevelFilter } from './types'

const signalLevelComparisonMap = {
  [SignalLevelFilter.equalOrLessThan]: (entryValue: number, filterValue: number) => entryValue <= filterValue,
  [SignalLevelFilter.greaterThan]: (entryValue: number, filterValue: number) => entryValue > filterValue
}

export default function filterFrequency(data: Array<FrequencyRow>, { signalHealth, signalLevel, ...stringFilters }: FrequenciesFilterState): Array<FrequencyRow> {
  let clonedData: Array<FrequencyRow> = JSON.parse(JSON.stringify(data))

  if (signalHealth) {
    clonedData = clonedData.filter(data => {
      const conditionForHealthy = data.PWR.isHealthy === true && data.BERPO.isHealthy === true
      const conditionForUnHealthy = data.PWR.isHealthy === false || data.BERPO.isHealthy === false

      return signalHealth === FrequencyHealthStatus.healthy ? conditionForHealthy : conditionForUnHealthy
    })
  }

  if (stringFilters[FrequenciesFilterField.TSID]) {
    clonedData = clonedData.filter(data => data.TSID === stringFilters[FrequenciesFilterField.TSID])
  }

  if (stringFilters[FrequenciesFilterField.modulation]) {
    clonedData = clonedData.filter(data => data.modulation === stringFilters[FrequenciesFilterField.modulation])
  }

  if (stringFilters[FrequenciesFilterField.frequency]) {
    clonedData = clonedData.filter(data => data.LF === stringFilters[FrequenciesFilterField.frequency])
  }

  if (signalLevel && signalLevel.filter !== '') {
    const signalLevelFilter = signalLevel.filter
    clonedData = clonedData.filter(data => signalLevelComparisonMap[signalLevelFilter](data.PWR.value, signalLevel.value))
  }

  return clonedData
}